import { Box } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

interface MainContentProps extends PropsWithChildren {}

export const MainContent: FC<MainContentProps> = ({ children }) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  )
}
